import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

// Declare the turnstile global variable from the script
declare let turnstile: any;

@Component({
  selector: 'app-turnstile',
  template: `
    <div id="cf-turnstile-container"></div>`
})
export class TurnstileComponent implements OnInit {
  @Input() siteKey: string;
  @Output() resolved = new EventEmitter<string>();

  ngOnInit() {
    // Wait a brief moment for the DOM element and script to align
    setTimeout(() => {
      if (typeof turnstile !== 'undefined') {
        turnstile.render('#cf-turnstile-container', {
          sitekey: this.siteKey,
          callback: (token: string) => {
            this.resolved.emit(token);
          },
          'error-callback': (err: any) => {
            console.error('Turnstile Error:', err);
          }
        });
      } else {
        console.error('Cloudflare Turnstile script failed to load.');
      }
    }, 100);
  }
}
